import "./LogosCarrousel.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDatabase,
  faTerminal,
  faGears,
} from "@fortawesome/free-solid-svg-icons";
import {
  faJs,
  faReact,
  faCss3Alt,
  faHtml5,
  faSass,
  faNodeJs,
  faBootstrap,
  faWordpress,
  faGit,
} from "@fortawesome/free-brands-svg-icons";

const LogosCarrousel = () => {
  return (
    <div className="carrousel">
      <div className="carrouselLogos">
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faJs} />
          <p>Javascript</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faHtml5} />
          <p>HTML</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faCss3Alt} />
          <p>CSS</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faReact} />

          <p>React</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faSass} />
          <p>SASS</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faNodeJs} />
          <p>Node.js</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faDatabase} />
          <p>MongoDB</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faBootstrap} />
          <p>Bootstrap</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faWordpress} />
          <p>Wordpress</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faGit} />
          <p>Git</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faDatabase} />
          <p>Firebase</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faTerminal} />
          <p>Command Line</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faGears} />
          <p>RESTful APIs</p>
        </div>
      </div>
      <div className="carrouselLogos">
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faJs} />
          <p>Javascript</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faHtml5} />
          <p>HTML</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faCss3Alt} />
          <p>CSS</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faReact} />

          <p>React</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faSass} />
          <p>SASS</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faNodeJs} />
          <p>Node.js</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faDatabase} />
          <p>MongoDB</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faBootstrap} />
          <p>Bootstrap</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faWordpress} />
          <p>Wordpress</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faGit} />
          <p>Git</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faDatabase} />
          <p>Firebase</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faTerminal} />
          <p>Command Line</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faGears} />
          <p>RESTful APIs</p>
        </div>
      </div>
      <div className="carrouselLogos">
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faJs} />
          <p>Javascript</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faHtml5} />
          <p>HTML</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faCss3Alt} />
          <p>CSS</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faReact} />

          <p>React</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faSass} />
          <p>SASS</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faNodeJs} />
          <p>Node.js</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faDatabase} />
          <p>MongoDB</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faBootstrap} />
          <p>Bootstrap</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faWordpress} />
          <p>Wordpress</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faGit} />
          <p>Git</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faDatabase} />
          <p>Firebase</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faTerminal} />
          <p>Command Line</p>
        </div>
        <div>
          <FontAwesomeIcon className="skillsIcon" icon={faGears} />
          <p>RESTful APIs</p>
        </div>
      </div>
    </div>
  );
};

export default LogosCarrousel;
